(function ($) {
    arsluna.widget.productFilter = {
        currentBreakpoint: null,
        init: function () {
            this.$container = $('#product-filter-portlet-main-content');
            if (!this.$container.length) return;
            this.loadWidget();
        },

        loadWidget: function () {
            const self = this;
            const $json = $('#product-filter-widget-params');
            this.widgetParams = {};
            if ($json.length) {
                try { this.widgetParams = JSON.parse($json.html()); } catch (e) { console.error(e); }
            }
            if (this.widgetParams && Object.keys(this.widgetParams).length > 0) {
                this.widgetParams.timestamp = new Date().getTime();
                $.ajax({
                    url: this.$container.data('endpoint'),
                    method: 'GET',
                    data: {
                        "request": "get_product_data_filter",
                        "params": JSON.stringify(this.widgetParams),
                        "timestamp": new Date().getTime()
                    },
                    beforeSend: function () { self.setLoading(true); }
                })
                    .done(function (html) {
                        self.$container.html(html);
                        self.afterRender();
                    })
                    .fail(function (xhr, status) {
                        console.error('Filter load error', status);
                        self.$container.html('<div class="filter-error">' + arsluna.msg.error.general.productFilterLoadError + '</div>');
                    })
                    .always(function () { self.setLoading(false); });
            }
        },

        afterRender: function () {
            this.$form = $('#fm_product_filter');
            this.initPortlet();
            this.showTrademarks = this.widgetParams.filter_trademarks === true;
            this.showPriceRange = this.widgetParams.filter_price_range === true;
            this.showDataFilter = this.widgetParams.filter_data === true;
            if (this.showTrademarks) this.initSelect2();
            if (this.showPriceRange) this.initSlider();
            if (this.showDataFilter) this.bindHierarchicalCheckbox();

            this.bindEvents();
        },

        initPortlet: function () {
            $("#product-filter-portlet-main")
                .addClass("arsluna-portlet-widget")
                .find(".product-filter-portlet-main-header")
                .addClass("arsluna-portlet-widget-header")
                .end()
                .find(".product-filter-portlet-main-content")
                .addClass("arsluna-portlet-widget-content");
            this.onResize();
        },

        onResize: function () {
            if (this.timeoutResize) {
                clearTimeout(this.timeoutResize);
            }
            this.timeoutResize = setTimeout(
                function () {
                    var newBreakpoint = getNumSkelSize();
                    if (newBreakpoint != arsluna.widget.productFilter.currentBreakpoint && newBreakpoint <= arsluna.widget.productFilter.$form.find('[name="breakpoint"]').val()) {
                        arsluna.widget.productFilter.hideFilter();
                    } else {
                        arsluna.widget.productFilter.showFilter();
                    }
                    arsluna.widget.productFilter.currentBreakpoint = newBreakpoint;
                },
                500
            );
        },

        hideFilter: function () {
            $('#product-filter-portlet-main-header').removeClass("portlet-opened").addClass("portlet-closed");
            $('#product-filter-portlet-main-content').hide('blind', 250);
        },

        showFilter: function () {
            $('#product-filter-portlet-main-header').removeClass("portlet-closed").addClass("portlet-opened");
            $('#product-filter-portlet-main-content').show('blind', 250);
        },

        initSelect2: function () {
            $('#filter-trademark-select').select2();
        },

        initSlider: function () {
            const $inputMin = parseFloat(this.$form.find('input[name="product_filter_price_range_min"]').val());
            const $inputMax = parseFloat(this.$form.find('input[name="product_filter_price_range_max"]').val());
            $("#product_filter_price_range_slider").slider({
                range: true,
                min: parseFloat(this.$form.find('input[name="price_min"]').val()),
                max: parseFloat(this.$form.find('input[name="price_max"]').val()),
                values: [$inputMin, $inputMax],
                step: 0.01,
                slide: function (event, ui) {
                    $("#product_filter_price_range").val(fNumToStr(ui.values[0], 2) + " - " + fNumToStr(ui.values[1], 2));
                    arsluna.widget.productFilter.$form.find('[name="product_filter_price_range_min"]').val(ui.values[0]);
                    arsluna.widget.productFilter.$form.find('[name="product_filter_price_range_max"]').val(ui.values[1]);
                }
            });
            $("#product_filter_price_range").val(fNumToStr($("#product_filter_price_range_slider").slider("values", 0), 2) +
                " - " + fNumToStr($("#product_filter_price_range_slider").slider("values", 1), 2));
        },

        bindHierarchicalCheckbox: function () {
            const $container = this.$form.find('#js-filter-hierarchical');
            $container.off('change', 'input[type="radio"][data-type="parent"]').on('change', 'input[type="radio"][data-type="parent"]', function () {
                const $input = $(this);
                const parentId = $input.val();
                const $childContainer = $input.closest('.filter-parent').find('.filter-child-container');
                $childContainer.empty();
                $.ajax({
                    url: '/ajax/get-filter-child.php',
                    data: { parent_id: parentId },
                    dataType: 'html'
                }).done(function (html) { $childContainer.html(html); })
                    .fail(function () { $childContainer.html('<div class="error">Napaka pri nalaganju podkategorij.</div>'); });
            });
        },

        getChild: function (input) {
            if (input.closest('.product-filter-portlet').nextAll().length > 0) {
                input.closest('.product-filter-portlet').nextAll().hide(
                    500,
                    function () {
                        input.closest('.product-filter-portlet').nextAll().remove();
                        loadChild(input);
                    }
                );
            } else {
                loadChild(input);
            }
        }, // END getChild

        loadChild: function (input) {
            let inputVal = input.val();
            if (inputVal !== lastInputVal) {
                lastInputVal = inputVal;
                $.ajax({
                    async: true,
                    type: "GET",
                    url: procPath + 'arsluna.ecommerce.get.php',
                    data: {
                        request: 'get_product_data_lov_child',
                        category: form.find('[name="category"]').val(),
                        product_data_lov_pk_parent: input.val(),
                        timestamp: new Date().getTime()
                    }
                }).done(function (r) {
                    $('#product-filter-hierarchical > .product-filter-container').append(r);
                    input.closest('.product-filter-portlet').nextAll().show(500);
                }).fail(function (httpObj, textStatus) {
                    console.error(textStatus);
                    loading = false;
                });
            }
        }, // END loadChild

        bindEvents: function () {
            $(window).on("resize", function (event) {
                arsluna.widget.productFilter.onResize();
            });
            $('#product-filter-hierarchical').on('change', 'input[type="radio"]', function (event) {
                let input = $(this);
                event.stopPropagation();
                arsluna.widget.productFilter.getChild(input);
            });

            $('#product-filter-submit').on('click', function (event) {
                event.preventDefault();
                arsluna.widget.productFilter.$form.submit();
            });

            $('#product-filter-reset').on('click', function (event) {
                event.preventDefault();
                arsluna.widget.productFilter.resetFilter();
            });

            $('#product-filter-portlet-main-header').on('click', function (event) {
                arsluna.widget.productFilter.toggleMain();
            });

            $('.product-filter-portlet-header').on('click', function (event) {
                let portlet = $(this);
                arsluna.widget.productFilter.toggle(portlet);
            });
        },

        resetFilter: function () {
            if (this.showTrademarks) $('#filter-trademark-select').val(null).trigger('change');
            if (this.showPriceRange) {
                const $slider = $("#product_filter_price_range_slider");
                const min = parseFloat(this.$form.find('input[name="price_min"]').data('default')) || 0;
                const max = parseFloat(this.$form.find('input[name="price_max"]').data('default')) || 500;
                $slider.slider('values', [min, max]);
                $slider.find('.slider-values').text(min + ' - ' + max);
                this.$form.find('input[name="price_min"]').val(min);
                this.$form.find('input[name="price_max"]').val(max);
            }
            if (this.showDataFilter) {
                this.$form.find('input[type="checkbox"],input[type="radio"]').prop('checked', false);
                this.$form.find('.filter-child-container').empty();
            }
        },

        toggleMain: function () {
            $('#product-filter-portlet-main-header').toggleClass("portlet-closed").toggleClass("portlet-opened");
            $('#product-filter-portlet-main-header').parents(".arsluna-portlet-widget:first").find(".product-filter-portlet-main-content").toggle('blind', 250);
        },

        toggle: function (portlet) {
            portlet.toggleClass("portlet-closed").toggleClass("portlet-opened");
            portlet.parents(".product-filter-portlet:first").find(".product-filter-portlet-content").toggle('blind', 250);
        },

        setLoading: function (state) {
            this.$container.toggleClass('is-loading', state);
        }
    };

    $(function () {
        arsluna.widget.productFilter.init();
    });

})(jQuery);
